module.exports = __webpack_public_path__ + "static/media/icon_combo-chart.a740c7fd.svg";